import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full my-8 md:my-10" }
const _hoisted_2 = { class: "flex w-full flex-wrap mb-6 md:mb-8" }
const _hoisted_3 = { class: "flex w-full mb-2" }
const _hoisted_4 = { class: "flex w-[60%]" }
const _hoisted_5 = { class: "flex flex-col !p-8" }
const _hoisted_6 = { class: "flex flex-col mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-wrap mb-6"
}
const _hoisted_8 = { class: "flex items-center w-fit mr-4 h-7 py-0.5 px-2 bg-gray-500 rounded" }
const _hoisted_9 = { class: "flex mb-10" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex flex-col items-center !p-8" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "circle-bg flex items-center justify-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "37",
    height: "37",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.74992 4.16659C7.74992 6.14638 6.14638 7.74992 4.16659 7.74992C2.18679 7.74992 0.583252 6.14638 0.583252 4.16659C0.583252 2.18679 2.18679 0.583252 4.16659 0.583252C6.14638 0.583252 7.74992 2.18679 7.74992 4.16659ZM32.8333 29.2499C30.8535 29.2499 29.2499 30.8535 29.2499 32.8333C29.2499 34.813 30.8535 36.4166 32.8333 36.4166C34.813 36.4166 36.4166 34.813 36.4166 32.8333C36.4166 30.8535 34.813 29.2499 32.8333 29.2499ZM25.6666 32.8333C25.6666 31.8443 24.8639 31.0416 23.8749 31.0416H11.3333C8.36984 31.0416 5.95825 28.63 5.95825 25.6666C5.95825 22.7032 8.36984 20.2916 11.3333 20.2916H25.6666C30.6062 20.2916 34.6249 16.2729 34.6249 11.3333C34.6249 6.39363 30.6062 2.37492 25.6666 2.37492H13.1249C12.1359 2.37492 11.3333 3.17759 11.3333 4.16659C11.3333 5.15559 12.1359 5.95825 13.1249 5.95825H25.6666C28.63 5.95825 31.0416 8.36984 31.0416 11.3333C31.0416 14.2967 28.63 16.7083 25.6666 16.7083H11.3333C6.39363 16.7083 2.37492 20.727 2.37492 25.6666C2.37492 30.6062 6.39363 34.6249 11.3333 34.6249H23.8749C24.8639 34.6249 25.6666 33.8223 25.6666 32.8333Z",
      fill: "white"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChTypography = _resolveComponent("ChTypography")!
  const _component_ch_typography = _resolveComponent("ch-typography")!
  const _component_ch_icon = _resolveComponent("ch-icon")!
  const _component_ch_button = _resolveComponent("ch-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ch_card = _resolveComponent("ch-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ChTypography, {
          "as-tag": "h3",
          variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled20Medium' : 'Untitled18Medium',
          class: "text-black dark:text-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.journey?.title ? _ctx.t('home.my-journey.main-journey') : _ctx.t('home.my-journey.keep-learning')), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ChTypography, {
          "as-tag": "span",
          variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled16Regular' : 'Untitled14Regular',
          class: "text-black dark:text-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('home.my-journey.subtitle')), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ])
    ]),
    (_ctx.journey?.title)
      ? (_openBlock(), _createBlock(_component_ch_card, {
          key: 0,
          class: "flex main-journey--container",
          withGradient: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ch_typography, {
                  "as-tag": "span",
                  variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled12Regular' : 'Untitled12Regular',
                  class: "text-black dark:text-white leading-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('home.my-journey.journey')), 1)
                  ]),
                  _: 1
                }, 8, ["variant"]),
                _createVNode(_component_ch_typography, {
                  "as-tag": "h3",
                  variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled20Medium' : 'Untitled18Medium',
                  class: "text-black dark:text-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.journey?.title), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]),
              (_ctx.journey?.tags)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journey.tags, (tag, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["flex items-center w-fit mr-2 h-7 py-0.5 px-2 bg-gray-500 rounded tag", tag]),
                        key: index
                      }, [
                        _createVNode(_component_ch_typography, {
                          variant: "Untitled12Regular",
                          class: "text-white capitalize",
                          asTag: "span"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2))
                    }), 128)),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ch_icon, {
                        icon: "fa-star",
                        size: "sm",
                        iconType: "fa-solid",
                        class: "text-brand-lemon-primary"
                      }),
                      _createVNode(_component_ch_typography, {
                        variant: "Untitled12Regular",
                        class: "text-white ml-2 capitalize",
                        asTag: "span"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('home.my-journey.main')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ch_typography, {
                  variant: _ctx.isDesktop || _ctx.isMediumDesktop ? 'Untitled14Regular' : 'Untitled14Regular',
                  class: "text-black dark:text-white",
                  asTag: "span"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.journey?.description), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/my-journey",
                  class: "flex items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ch_button, {
                      class: "w-25",
                      buttonVariant: "primary",
                      size: "small",
                      label: _ctx.t('home.my-journey.btn-journey')
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_ch_card, {
          key: 1,
          class: "flex main-journey--container-empty border border-dashed",
          withGradient: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_ch_typography, {
                variant: "Untitled16Regular",
                class: "text-white mb-2 text-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('home.my-journey.empty-journey-title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ch_typography, {
                variant: "Untitled12Regular",
                class: "text-white text-center journeys--link",
                innerHTML: _ctx.link
              }, null, 8, ["innerHTML"])
            ])
          ]),
          _: 1
        }))
  ]))
}